import { useEffect } from 'react';

import Decimal from 'decimal.js';
import { useFormContext } from 'react-hook-form';

import { parseToFloat } from '../../../../utils/parseToFloat';

const calculateSurcharge = (
  totalBonus: string,
  employerCost: string
): number => {
  const floatTotalBonus = new Decimal(parseToFloat(totalBonus));
  const floatEmployerCost = new Decimal(parseToFloat(employerCost));

  const x = new Decimal(1).plus(floatEmployerCost);
  return floatTotalBonus.times(x).plus(floatEmployerCost).toDP(4).toNumber();
};

export const useCalculateSurcharges = (
  totalBonusField: string,
  employerCostField: string,
  surchargeField: string
) => {
  const { setValue, watch } = useFormContext();

  const watchedTotalBonus = watch(totalBonusField);
  const watchedEmployerCost = watch(employerCostField);

  const watchedSurcharge = watch(surchargeField);

  useEffect(() => {
    const calculatedSurcharge = calculateSurcharge(
      watchedTotalBonus,
      watchedEmployerCost
    );

    if (watchedSurcharge !== calculatedSurcharge) {
      setValue(surchargeField, calculatedSurcharge);
    }
  }, [watchedTotalBonus, watchedEmployerCost, watchedSurcharge]);
};
